export const CommentIcon = () => (
    <span className="comment-icon">💬</span>
);